import React, { type MouseEvent, forwardRef } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import { Flex, Text, Box } from '@atlaskit/primitives/compiled';
import AIContainer from '../ai-container/index.tsx';
import { AiIcon } from '../ai-icon/index.tsx';

type Props = {
	autoFocus?: boolean;
	onClick: (_: MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void;
};

export const AIButton = forwardRef<HTMLElement, Props>(({ autoFocus, onClick }: Props, ref) => (
	<AIContainer spacing="none" isShadow>
		<Button
			ref={ref}
			// eslint-disable-next-line jsx-a11y/no-autofocus
			autoFocus={autoFocus}
			appearance="subtle"
			onClick={onClick}
			spacing="none"
			aria-label="AI"
		>
			<Box paddingBlock="space.050" paddingInline="space.100">
				<Flex gap="space.050" alignItems="center" justifyContent="center">
					<AiIcon label="" size="small" />
					<Text color="color.text.selected" weight="medium">
						AI
					</Text>
				</Flex>
			</Box>
		</Button>
	</AIContainer>
));
